import { isBookableTransport, DEFAULT_TRANSPORT_TYPE } from '@libs/utils';
import type { Serializer } from '@libs/utils';
import { ConnectionType } from '@libs/maps';

export const ConnectionTypeSerializer: Serializer<ConnectionType> = {
  serialize: function (connectionType: ConnectionType): string {
    return connectionType.toString();
  },
  deserialize: function (value: string): ConnectionType {
    const connectionType = ConnectionType[parseInt(value)] as
      | ConnectionType
      | undefined;

    if (!connectionType) {
      return DEFAULT_TRANSPORT_TYPE;
    }

    const transportToDeserialize = ConnectionType[
      connectionType
    ] as unknown as ConnectionType;

    return isBookableTransport(transportToDeserialize)
      ? DEFAULT_TRANSPORT_TYPE
      : transportToDeserialize;
  },
};
